import { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVitals } from "services/patient/vitals"
import { setVitals } from "store/slices/vitalSlice"
import { RootState } from "store";
import ReportItem from "components/ReportItem"

const Report = () => {

    const dispatch = useDispatch();
    const vitals = useSelector((state:RootState )=> state.vitalData.vitals)

    useEffect(()=> {
        getVitals().then(
            res => dispatch(setVitals(res.data.result))
        )
    },[dispatch])

    return(
        <div className="p-10" >
            <h4>Report</h4>
            
            <div className="p-4 w-full overflow-hidden my-4 rounded-lg " >
                <div><ReportItem stats={vitals.filter(e=>e.vital_type==="BP")} type='Blood Pressure History' /></div> 
                <div><ReportItem stats={vitals.filter(e=>e.vital_type==="WE")} type='Weight History' /></div> 
                <div><ReportItem stats={vitals.filter(e=>e.vital_type==="GL")} type='Glucose Level History' /></div> 
            </div>
        </div>
    )
}

export default Report
